<div class="container">
  <header class="flex-header table-page-header dashboard-header">
    <div class="flex-item for-phone-show left-header">
      <hf-nav-button></hf-nav-button>

      <hf-custom-button
        type="button"
        [class]="'square-btn btn-clear'"
        icon="arrow_back"
        iconPos="center"
        (click)="onBack()"
      >
      </hf-custom-button>

      <div class="header-text-content">
        <span class="client-header">
          <div class="heading-part">Clients</div>
          <i class="material-icons header-crumbs-divider heading-part">chevron_right</i>
          <div class="heading-part">{{ clientData?.fullName ? clientData?.fullName : '&hellip;' }}</div>
        </span>
        <hf-warning-badge
          *ngIf="clientData?.vulnerableCustomer && tenantConfigService.isFeatureEnabled('vulnerableCustomer')"
        ></hf-warning-badge>
      </div>
    </div>

    <div class="flex-item-justify-end">
      <div class="single-button-wrap">
        <hf-custom-button
          *ifPermission="'MORTGAGE_NEW'"
          class="button-primary btn-md"
          label="Add Mortgage"
          icon="add_circle"
          iconPos="left"
          textPos="left"
          (click)="onAddMortgage()"
        >
        </hf-custom-button>
      </div>
      <div class="single-button-wrap">
        <hf-custom-button
          *ifPermission="'PROTECTION_NEW'"
          [class]="'button-primary btn-md'"
          label="Add Protection"
          icon="add_circle"
          iconPos="left"
          textPos="left"
          (click)="onAddProtection()"
        >
        </hf-custom-button>
      </div>

      <hf-custom-button
        *ifPermission="'CLIENT_EDIT'"
        type="button"
        [class]="'square-btn btn-clear'"
        icon="edit"
        iconPos="center"
        [routerLink]="['./edit']"
      >
      </hf-custom-button>
    </div>
  </header>

  <div class="client-dashboard-content">
    <div class="client-heading-container">
      <hf-information-box
        [heading]="'Last Activity'"
        [value]="clientData?.lastLogin ? { text: clientData?.lastLogin | date: 'd MMM y' } : ''"
      >
      </hf-information-box>
      <div class="header_flex-space"></div>
    </div>

    <div class="client-details-container">
      <section class="client-details-container_section">
        <div class="heading"><h3>Client Details</h3></div>
        <div class="client-details-container-inner">
          <div class="info-summary-table">
            <div>Name</div>
            <div>{{ clientData?.fullName }}</div>

            <div>Email</div>
            <div>{{ clientData?.email }}</div>

            <div>Phone</div>
            <div>{{ clientData?.phonePrefix }} {{ clientData?.phone }}</div>

            <div>Date Added</div>
            <div>{{ clientData?.createdDate ? (clientData?.createdDate | date: 'd MMM y') : '' }}</div>

            <div class="credit-report">Credit Report</div>
            <div class="icon-flex-header">
              {{ clientData?.creditSearchOptOut ? 'No' : 'Yes' }}
              <hf-icon-button
                class="credit-report-opt-out-btn"
                icon="swap_horizontal_circle"
                (click)="onOptOutClicked()"
              ></hf-icon-button>
            </div>
          </div>
        </div>
      </section>
      <ng-container *ngIf="clientData?.commsPreferences">
        <section class="contact-preferences_essential-container">
          <div class="heading">
            <h3>Contact Preferences</h3>
            <hf-icon-button
              *ifPermission="'CLIENT_EDIT'"
              icon="edit"
              [isCircle]="true"
              [routerLink]="['./edit-contact-preferences']"
            >
            </hf-icon-button>
          </div>
          <div class="client-details-container-inner">
            <div class="info-summary-table_contact-preferences">
              <h3 class="heading_full-width">Essential Updates</h3>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field">Whatsapp</div>
                <div class="contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.essentialWhatsapp"></hf-opt-in-out>
                </div>
              </div>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field">Post</div>
                <div class="contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.essentialPost"></hf-opt-in-out>
                </div>
              </div>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field remortgage_reminder">Remortgage Reminders</div>
                <div class="remortgage-container contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.remortgageReminders"></hf-opt-in-out>
                </div>
              </div>
              <ng-container *ngIf="clientData?.commsPreferences?.preferenceNote">
                <div class="contact-preference_flex-field">
                  <div class="contact-preference-field">Contact Note</div>
                  <div class="contact-preference-notes-container">
                    <hf-contact-note [contactNote]="clientData?.commsPreferences?.preferenceNote"></hf-contact-note>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </section>
      </ng-container>
      <ng-container *ngIf="clientData?.commsPreferences">
        <section class="contact-preferences_optional-container">
          <div class="heading"></div>
          <div class="client-details-container-inner">
            <div class="info-summary-table_contact-preferences">
              <h3 class="heading_full-width">Optional Updates</h3>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field">Email</div>
                <div class="contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.nonEssentialEmail"></hf-opt-in-out>
                </div>
              </div>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field">Phone</div>
                <div class="contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.nonEssentialPhone"></hf-opt-in-out>
                </div>
              </div>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field">WhatsApp</div>
                <div class="contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.nonEssentialWhatsapp"></hf-opt-in-out>
                </div>
              </div>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field">Post</div>
                <div class="contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.nonEssentialPost"></hf-opt-in-out>
                </div>
              </div>

              <div class="contact-preference_flex-field">
                <div class="contact-preference-field">Newsletter</div>
                <div class="contact-preference-opt">
                  <hf-opt-in-out [optedIn]="clientData?.commsPreferences?.mortgageMarketUpdateEmail"></hf-opt-in-out>
                </div>
              </div>
            </div>
          </div>
        </section>
      </ng-container>
    </div>
  </div>

  <div class="table-wrap">
    <div class="ds-table">
      <div class="ds-table-headings">
        <div class="entity"><span>Type</span></div>
        <div><span>Created</span></div>
        <div><span>Role</span></div>
        <div style="flex: 2.25"><span>Reference</span></div>
        <div><span>End/Claw Back Date</span></div>
        <div style="min-width: 161px"><span>Status</span></div>
      </div>

      <a *ngFor="let row of clientData?.productList" [routerLink]="['../..', getProductUrl(row), row.id]">
        <div class="table-row">
          <div data-mobileTitle="Type" class="entity" [ngClass]="row.type">
            <i *ngIf="row.type === 'MORTGAGE'" class="material-icons">home</i>
            <i *ngIf="row.type === 'PROTECTION'" class="material-icons">security</i>
          </div>
          <div data-mobileTitle="Created">{{ row.createdDate ? (row.createdDate | date: 'd MMM y') : '--' }}</div>
          <!-- <div data-mobileTitle="Type">{{row.type ? PRODUCT_TYPE[row.type] : '--'}}</div> -->
          <div data-mobileTitle="Role">{{ row.role ? PRODUCT_ROLE[row.role] : '--' }}</div>
          <div data-mobileTitle="Reference" style="flex: 2.25">{{ getReference(row) }}</div>
          <div data-mobileTitle="End/Claw Back Date">
            {{ row.productEndDate ? (row.productEndDate | date: 'd MMM y') : '--' }}
          </div>
          <div data-mobileTitle="Status" style="display: block; color: white">
            <hf-custom-pill
              [label]="row.state ? getStateType(row.state) : '--'"
              [type]="'CUSTOM'"
              [status]="row.state | lowercase"
            ></hf-custom-pill>
          </div>
        </div>
      </a>
    </div>

    <div *ngIf="!clientData?.productList || clientData?.productList.length === 0" class="no-results">
      Client has no mortgages or protection yet
    </div>
  </div>
</div>

<div class="sidepanes-anchor">
  <router-outlet></router-outlet>
</div>
